import { AttachmentFile } from "../model/Attachment";
export interface AddressRequest {
    address: string | null | undefined;
    city: string | null | undefined;
    provinceId: number | null;
    countryId: number | null;
    postalCode: string | null | undefined;
}

export namespace EditableAddress {
    export interface Fields extends AddressRequest {}

    export const Empty = (): Fields => {
        return {
            address: "",
            city: "",
            provinceId: null,
            countryId: null,
            postalCode: ""
        };
    };

    export const ToRequest = (fields: Fields): AddressRequest => fields;
}

export interface FileUploadRequest {
    id?: number;
    name: string;
    contentType: string;
    data?: string;
    markCompliant?: boolean;
}

export const FileUploadRequestFromAttachmentFile = (file: AttachmentFile): FileUploadRequest => {
    return {
        id: file.id,
        name: file.name,
        contentType: file.contentType
    };
};



// WEBPACK FOOTER //
// ./src/requests/CommonRequest.ts